import { useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { ETestIds } from '../../../../constants/testIds';
import { setActiveMasterButton } from '../../../../redux/landingSlice';
import { EFillApplicationStickyButtonType } from '../types';
import { useIsDesktop } from '../../../../hooks/common';

export const useMobileStickyButtons = (ref: HTMLElement | null) => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const isFiltersVisible = useRef<boolean>(true);
  const isPresentationBtnVisible = useRef<boolean>(true);

  useEffect(() => {
    if (isDesktop) {
      return;
    }

    // Сбрасываем состояние при инициализации
    dispatch(setActiveMasterButton(null));

    const presentationBtn = document.querySelector(`[data-testid=${ETestIds.PresentationBtn}]`) as Element;
    const showOffersBtn = document.querySelector(`[data-testid=${ETestIds.ShowOffersButton}]`) as Element;
    const documentBody = document.body as HTMLBodyElement;
    const controlsContainer = document.querySelector(`[data-testid=${ETestIds.ControlsContainer}]`) as Element;
    const seoBlock = document.querySelector(`[data-testid=${ETestIds.InformationalSeo}]`) as Element;

    /**
     * Костыль для того, чтобы sticky кнопки не перекрывали футер, убрать после релиза фичи
     * */
    documentBody.style.paddingBottom = '110px';

    const topButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            isPresentationBtnVisible.current = true;
            dispatch(setActiveMasterButton(null));
          } else {
            isPresentationBtnVisible.current = false;
            dispatch(setActiveMasterButton('showOffers'));
          }
        });
      },
      {
        threshold: 0.1,
        root: null,
      },
    );

    const bottomButtonObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!isPresentationBtnVisible.current) {
              dispatch(setActiveMasterButton('showOffers'));
            }
          } else {
            if (!isFiltersVisible.current) {
              dispatch(setActiveMasterButton(EFillApplicationStickyButtonType.TOP));
            }
          }
        });
      },
      {
        threshold: 0.1,
        root: null,
      },
    );

    const controlsContainerObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            isFiltersVisible.current = true;
          } else {
            isFiltersVisible.current = false;
          }
        });
      },
      { threshold: 0.1, root: null },
    );

    const seoBlockObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isFiltersVisible.current) {
            dispatch(setActiveMasterButton(EFillApplicationStickyButtonType.TOP));
          }
        });
      },
      { threshold: 0.1, root: null },
    );

    topButtonObserver.observe(presentationBtn);
    bottomButtonObserver.observe(showOffersBtn);
    controlsContainerObserver.observe(controlsContainer);
    seoBlockObserver.observe(seoBlock);

    return () => {
      topButtonObserver.disconnect();
      bottomButtonObserver.disconnect();
      controlsContainerObserver.disconnect();
      seoBlockObserver.disconnect();
    };
  }, [isDesktop, dispatch, ref]);
};
